<template>
  <el-row>
    <el-col>
      <el-card shadow="never">
        <div>
          <VueChart
            chart-type="Bar"
            :chart-data="value"
            :options="options"
            :style="myStyles"
          />
        </div>
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import VueChart from '@/components/Chart'

export default {
  components: {
    VueChart
  },
  props: {
    chartType: {
      type: String,
      required: false,
      default: 'Line'
    },
    chartOptions: {
      type: Object,
      required: false,
      default: () => ({})
    },
    params: {
      type: Object,
      required: false,
      default: () => ({})
    }
  },
  data () {
    return {
      consignment: null,
      title: 'Pricing',
      breadcrumb: {
        name: 'Pricing',
        route: { name: 'freight-consignments-v3-consignment-pricing', params: { consignmentId: this.$route.params.consignmentId } }
      },
      actions: [
      ],
      loading: true,
      options: {
        title: {
          display: true,
          lineHeight: 1.6,
          padding: 5,
          text: [
            this.title
          ]
        },
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          xAxes: [{
            stacked: this.chartType === 'Bar',
            ticks: {
              display: this.chartType !== 'Pie'
            },
            gridLines: {
              display: this.chartType !== 'Pie'
            }
          }],
          yAxes: [{
            stacked: this.chartType === 'Bar',
            gridLines: {
              display: this.chartType !== 'Pie'
            },
            ticks: {
              // Include a dollar sign in the ticks
              callback: (value, index, values) => {
                if (this.chartType === 'Pie') {
                  return ''
                } else {
                  return `$${value}`
                }
              }
            }
          }]
        },
        tooltips: {
          enabled: true,
          mode: 'single',
          callbacks: {
            label: (tooltipItems, data) => {
              return `${data.labels[tooltipItems.index]}: ${this.$filters.currency(data.datasets[tooltipItems.datasetIndex].data[tooltipItems.index])}`
            }
          }
        }
      }
    }
  },
  computed: {
    myStyles () {
      return {
        position: 'relative',
        height: '90%'
      }
    }
  },
  created () {
    this
      .$sdk
      .consignment
      .read(this.$route.params.consignmentId, request => {})
      .then(res => { this.consignment = res })
      .finally(() => { this.isLoading = false })
  },
  methods: {

  }
}
</script>
